import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { TimeSlot } from "../../types/availability.definition";
import { RootState } from "../store";

interface AvailabilitiesState {
  timeSlots: TimeSlot[];
  loading: boolean;
  error: string | null;
}

const initialState: AvailabilitiesState = {
  timeSlots: [],
  loading: true,
  error: null,
};

const availabilitiesSlice = createSlice({
  name: "availabilities",
  initialState,
  reducers: {
    getAvailabilitiesRequest: (
      state,
      _action: PayloadAction<{ id: number }>
    ) => {
      state.loading = true;
      state.error = null;
    },
    getAvailabilitiesInRangeRequest: (
      state,
      _action: PayloadAction<{
        id: number;
        startDate?: string;
        endDate?: string;
      }>
    ) => {
      state.loading = true;
      state.error = null;
    },
    getAvailabilitiesSuccess: (
      state,
      { payload }: PayloadAction<TimeSlot[]>
    ) => {
      state.error = null;
      state.timeSlots = payload;
      state.loading = false;
    },
    getAvailabilitiesFailure: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
      state.timeSlots = [];
    },
  },
});

export const {
  getAvailabilitiesRequest,
  getAvailabilitiesInRangeRequest,
  getAvailabilitiesSuccess,
  getAvailabilitiesFailure,
} = availabilitiesSlice.actions;

export default availabilitiesSlice.reducer;
export const selectAvailabilitiesData = (state: RootState) =>
  state.availabilities;
